// extracted by mini-css-extract-plugin
export default {"text":"burger-menu_text__R3VH6","speedDial":"burger-menu_speedDial__WCAZa","speedDialAction":"burger-menu_speedDialAction__iyB1c","icon":"burger-menu_icon__8yLhF"};